import { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import api from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const empty = { name: "", html_or_image: "", link: "", placement: "sidebar", active: true };

export default function AdsAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);
  const load = () => api.get("/ads", { params: { active: undefined } }).then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/ads", form); toast.success("Anúncio cadastrado!"); setForm(empty); load(); }
    catch { toast.error("Erro"); }
  };
  const remove = async (id) => { if (!window.confirm("Excluir?")) return; await api.delete(`/ads/${id}`); load(); };

  return (
    <AdminLayout>
      <div data-testid="admin-ads">
        <h1 className="font-serif-display text-4xl font-bold">Anúncios</h1>
        <p className="font-sans-ui text-sm text-zinc-500">Gerencie campanhas e parcerias publicitárias</p>
        <div className="grid md:grid-cols-3 gap-6 mt-6">
          <form onSubmit={submit} className="border border-zinc-300 bg-white p-4 space-y-3">
            <h2 className="overline">Novo anúncio</h2>
            <input type="text" placeholder="Nome interno" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" data-testid="ad-name" />
            <textarea placeholder="URL da imagem OU HTML" required rows={3} value={form.html_or_image} onChange={e => setForm({...form, html_or_image: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" data-testid="ad-content" />
            <input type="url" placeholder="Link de destino" value={form.link} onChange={e => setForm({...form, link: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" />
            <select value={form.placement} onChange={e => setForm({...form, placement: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm">
              <option value="top">Topo</option>
              <option value="sidebar">Sidebar</option>
              <option value="inline">Inline</option>
              <option value="footer">Rodapé</option>
            </select>
            <label className="flex items-center gap-2 font-sans-ui text-sm"><input type="checkbox" checked={form.active} onChange={e => setForm({...form, active: e.target.checked})} /> Ativo</label>
            <button type="submit" className="bg-black text-white px-4 py-2 w-full font-sans-ui text-sm uppercase tracking-widest font-semibold" data-testid="ad-submit"><Plus size={14} className="inline mr-2"/>Cadastrar</button>
          </form>
          <div className="md:col-span-2 space-y-3">
            {items.map(a => (
              <div key={a.id} className="border border-zinc-300 bg-white p-3 flex gap-4 items-center">
                <div className="flex-1">
                  <p className="font-serif-display font-semibold">{a.name}</p>
                  <p className="font-sans-ui text-xs text-zinc-500">{a.placement} · {a.impressions} impressões · {a.clicks} cliques · {a.active ? "Ativo" : "Inativo"}</p>
                </div>
                <button onClick={() => remove(a.id)} className="p-1.5 border border-zinc-300 text-red-700"><Trash2 size={14}/></button>
              </div>
            ))}
            {items.length === 0 && <p className="text-center text-zinc-500 font-sans-ui p-6 border border-zinc-300 bg-white">Nenhum anúncio.</p>}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
